import React, { memo, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Tag } from 'appkit-react';

import { CardWithLayout } from '@modules/insights/card';
import { insightModals, SEGMENTS } from '@model';
import actions from '@flux/action';
import { findSubModuleName } from '@hooks/useSubmoduleName';

const CategoryTag = ({ category }) => (
  <Tag className="insight-card-tag font-weight-medium">
    {category?.displayCategory.replace('_', '/') || 'connectedData'}
  </Tag>
);

const getInsightSectionProps = (insightData = {}, customizedModules) => {
  const { category, segment } = insightData;
  if (!category || !segment) {
    return null;
  }

  const module =
    findSubModuleName(segment, customizedModules) || SEGMENTS[segment];
  const { displayCategory } = category || {};

  if (!displayCategory || !module) {
    return null;
  }

  return {
    module,
    component: displayCategory,
  };
};

const InsightList = ({ data, projectId }) => {
  const history = useHistory();
  const handleJumpToAnalysis = (data) => {
    const {
      segment,
      category: { displayCategory = '' },
    } = data;
    const state = {
      category: displayCategory,
      // segment,
      currentDetail: data,
      type: insightModals.INSIGHT_DETAIL,
    };
    let pathname = `/analysis/${segment}`;
    if (segment === 'dealrationale') {
      pathname = `/insights/${segment}`;
    }
    history.push({
      pathname,
      state,
      search: `?projectId=${projectId}`,
    });
  };

  const { customizedModules = [] } = useSelector(({ projects }) => ({
    customizedModules: projects?.customizedModules,
  }));

  const insightsCard = useMemo(
    () =>
      data.map((e) => ({
        id: e.insightId,
        title: e.title,
        content: e.summary,
        insight: e.insight,
        segmengt: e.segment,
        sectionCommentProps: getInsightSectionProps(e, customizedModules),
        cate: <CategoryTag category={e.category} />,
        action: {
          title: 'Jump To Insight',
          clickHandler: () => handleJumpToAnalysis(e),
        },
      })),
    [data, customizedModules],
  );

  return (
    <>
      <div className="insights-cards insights-module">
        <CardWithLayout
          cardsData={insightsCard}
          animActive
          collection="insight"
        />
      </div>
    </>
  );
};
const mapStateToProps = ({ common, insights }) => {
  const projectId = common.currentId;

  const { principleData = [], insightsData = [] } =
    insights.insightsData[projectId] || {};
  return {
    principleData,
    insightsData,
    projectId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  async fetchData(params) {
    await dispatch(actions.fetchGdPrincipleAndInsightstData(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(InsightList));
